import { render } from "./SkilupRegComponent.vue?vue&type=template&id=67aeee04&scoped=true&ts=true"
import script from "./SkilupRegComponent.vue?vue&type=script&lang=ts"
export * from "./SkilupRegComponent.vue?vue&type=script&lang=ts"

import "./SkilupRegComponent.vue?vue&type=style&index=0&id=67aeee04&scoped=true&lang=css"
import "./SkilupRegComponent.vue?vue&type=style&index=1&id=67aeee04&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67aeee04"]])

export default __exports__